React = require 'react'
_ = require 'underscore'
Util = require 'lib/util'
{ featureFlagClient } = require 'common/lib/feature-flag-client'
# Using `create_board` here to share strings with parent template
t = require('views/internal/recup-with-helpers')('create_board')
ClientConfig = require 'debug/client-config'
localizeCount = require 'lib/localize-count'

isDesktop = ClientConfig.get('appId') == 'desktop'

module.exports = class OrgChooserComponent extends React.Component
  displayName: 'OrgChooserComponent'

  constructor: (props) ->
    super props
    @state =
      boardLimitsFlag: featureFlagClient.get('bc.board_limits', false)

    @onLdUpdateBoardLimit = @onLdUpdateBoardLimit.bind(@)

  onLdUpdateBoardLimit: (newVal) ->
    @setState({ boardLimitsFlag: newVal })

  componentDidMount: ->
    setTimeout (=> @chooserElem?.focus()), 10
    featureFlagClient.on 'bc.board_limits', @onLdUpdateBoardLimit

  componentWillUnmount: ->
    featureFlagClient.off 'bc.board_limits', @onLdUpdateBoardLimit

  render: t.renderable ->
    { onSelect, orgs, selectedOrg } = @props
    { boardLimitsFlag } = @state
    onNoTeamClick = @onNoTeamClick.bind @

    setChooserElem = (elem) => @chooserElem = elem
    setSelectedElem = (elem) => @selectedElem = elem

    t.ul '.pop-over-list.org-chooser', { ref: setChooserElem, tabIndex: 0 }, ->
      t.li ->
        t.a {
          href: '#'
          onClick: onNoTeamClick
          ref: if !selectedOrg? then setSelectedElem
        }, ->
          t.format 'no team'
          if !selectedOrg?
            t.icon 'check'

      orgs.forEach (org) ->
        isSelected = selectedOrg? && org.model.id == selectedOrg.model.id
        boardsRemaining = org.model.getFreeBoardsRemaining()
        showBoardsRemaining = boardLimitsFlag &&
          !isDesktop &&
          org.model.isCloseToFreeBoardLimit()
        boardsOver = org.model.getFreeBoardsOver() || 0
        showBoardsOver = boardsOver > 0

        t.li { key: org.model.id }, ->
          t.a '.org-item', {
            href: '#'
            onClick: (e) ->
              Util.stop e
              onSelect org
          }, ->
            t.div ->
              t.text org.model.get 'displayName'
              if isSelected
                t.icon 'check'
            if showBoardsRemaining
              t.div '.free-board-limit-info', ->
                t.text localizeCount('boards-remaining', boardsRemaining)
                if showBoardsOver
                  t.text ' | '
                  t.text localizeCount('boards-over', boardsOver)

  onNoTeamClick: (e) =>
    Util.stop e
    @props.onSelect null



// WEBPACK FOOTER //
// ./app/scripts/views/board-create/org-chooser-component.coffee